import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import config from '@/config';

/**
 * Inicializa o Firebase do admin web.
 *
 * Regra do ecossistema: 1 BU = 1 projeto Firebase. Este deploy do admin é por
 * BU, então a config vem das envs `REACT_APP_*` (ver `src/config.ts`) do projeto
 * Firebase daquela BU.
 *
 * `firebaseAuth` é usado no login (signInWithEmailAndPassword), no reset de senha
 * e no interceptor de requests (anexa o ID token como Bearer).
 */
const firebaseApp = initializeApp(config.firebase);

export const firebaseAuth = getAuth(firebaseApp);

/**
 * Resolve na primeira vez que o SDK termina de restaurar a sessão persistida.
 * `firebaseAuth.currentUser` fica `null` até esse momento mesmo quando existe
 * sessão salva — quem for ler `currentUser` logo após um reload precisa
 * esperar por isso, senão trata um usuário autenticado como deslogado.
 */
export const firebaseAuthReady = new Promise<void>((resolve) => {
  const unsubscribe = onAuthStateChanged(firebaseAuth, () => {
    unsubscribe();
    resolve();
  });
});
